/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Model, { belongsTo } from '@ember-data/model';
import { attr } from '@ember-data/model';
import type Setting from './setting';

export default class Copy extends Model {
  @attr('string') declare appId: string;
  @attr('string') declare locale: string;
  @attr('string') declare text: string;

  @belongsTo('consent-banners/setting', { async: false })
  declare setting: Setting;
}
